import api from './api';

export interface IVSTokenResponse {
  token: string;
  participantId: string;
  expiresAt: string;
  capability: 'PUBLISH' | 'SUBSCRIBE';
  streamId: string;
}

export const ivsService = {
  async createParticipantToken(streamId: string, capability: 'PUBLISH' | 'SUBSCRIBE' = 'PUBLISH'): Promise<IVSTokenResponse> {
    return api.post<IVSTokenResponse>('/ivs/token', { streamId, capability });
  }
};

export default ivsService;
